import API from "./api";

export interface VerificationFilters {
  verdict?: string;
  categorieId?: number;
  /** true : n'expose que les vérifications publiées — à utiliser depuis les pages publiques. */
  estPublic?: boolean;
}

const VerificationService = {
  getAll: async (filters?: VerificationFilters) => {
    const response = await API.get("/verifications", {
      params: {
        verdict: filters?.verdict,
        categorieId: filters?.categorieId,
        estPublic: filters?.estPublic,
      },
    });
    return response.data.donnees;
  },

  getById: async (id: number) => {
    const response = await API.get(`/verifications/${id}`);
    return response.data.donnees;
  },

  getBySlug: async (slug: string) => {
    const response = await API.get(`/verifications/slug/${slug}`);
    return response.data.donnees;
  },

  create: async (payload: any) => {
    const response = await API.post("/verifications", payload);
    return response.data.donnees;
  },

  update: async (id: number, payload: any) => {
    const response = await API.put(`/verifications/${id}`, payload);
    return response.data.donnees;
  },

  getMesVerifications: async () => {
    const response = await API.get("/verifications/mes-verifications");
    return response.data.donnees;
  },

  valider: async (id: number) => {
    const response = await API.post(`/verifications/${id}/valider`);
    return response.data.donnees;
  },

  refuser: async (id: number) => {
    const response = await API.post(`/verifications/${id}/refuser`);
    return response.data.donnees;
  },

  delete: async (id: number) => {
    const response = await API.delete(`/verifications/${id}`);
    return response.data.donnees;
  },

  uploadAttachment: async (verificationId: number, file: File, options?: { type?: string; libelle?: string }) => {
    const formData = new FormData();
    formData.append("file", file);
    if (options?.type) formData.append("type", options.type);
    if (options?.libelle) formData.append("libelle", options.libelle);

    const response = await API.post(`/verifications/${verificationId}/attachments`, formData);
    return response.data.donnees;
  },

  deleteAttachment: async (verificationId: number, attachmentId: number) => {
    const response = await API.delete(`/verifications/${verificationId}/attachments/${attachmentId}`);
    return response.data.donnees;
  },
};

export default VerificationService;